import React from 'react';
import CustomerInlineLabelInput from 'components/Customer/CustomerInlineLabelInput';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import { DidYouMeanCombo } from 'components/Common/DidYouMeans/DidYouMeanCombo';

const JotrFields = ({ isEditable, index, isWithholdingResidence, isPrimary, jurisdictions,
  onRemoveTaxResidence, onChangeWhdResidence, onMakePrimaryClick, isPrimaryEditable
}) => (
  <div className="customer-form-panel full-height">
    <div className="panel">
      <div className="panel-data">
        <div className="columns">
          <div className="col-12">
            <div className="form-group address-pills">
              <h3 className="col-4" id={ `tax-residence-header-${ index + 1 }` }>
                <strong>{`Tax Residence ${ index + 1 }`}</strong>
              </h3>
              <div className="pills col-8">
                {isEditable && <button
                  className="btn btn-sm btn-danger"
                  type="button"
                  id={ `remove-jotr-${ index }` }
                  onClick={ () => onRemoveTaxResidence(index) }
                >
                  <span className="icon icon-delete" />
                  </button>}
                {isPrimary
                  && <div
                    className="chip chip--active"
                    title="This Tax Residence is used for Presumption Rules, US indicia"
                    id={ `primary-jotr-pill-${ index }` }
                  >
                    PRIMARY
                    </div>}
                {!isPrimary && (isEditable || isPrimaryEditable)
                    && <button
                      type="button"
                      className="chip chip--address chip--make-primary"
                      title="Click here to make this Tax Residence the Primary (used for the Prepopulation of Form Data and Data Exports)"
                      onClick={ () => onMakePrimaryClick(index) }
                      id={ `make-primary-jotr-button-${ index }` }
                    >
                      PRIMARY</button>}
                {isWithholdingResidence && <div
                  className="chip chip--whd"
                  title="This Tax Residence is used for Withholding Calculations"
                  id={ `whd-residence-pill-${ index }` }
                >WHD
                  </div>}
                {isEditable && !isWithholdingResidence && <button
                  type="button"
                  className="chip chip--whd chip--make-whd"
                  title="Click here to make this Address used for Withholding Calculations"
                  onClick={ () => onChangeWhdResidence(index) }
                  id={ `make-whd-residence-button-${ index }` }
                >WHD
                  </button>}
              </div>
            </div>
            <div className="form-group columns">
              <label className="form-label col-4" id={ `customer-tax-residence[${ index }]-country-label` }>Country</label>
              <span className="col-7">
                <Field
                  name="country"
                  component={ DidYouMeanCombo }
                  items={ jurisdictions?.map(x => x.name) ?? [] }
                  disabled={ !isEditable }
                  className="form-select"
                  id={ `customer-tax-residence[${ index }]-country` }
                />
              </span>
            </div>
            <Field
              name="tin"
              component={ CustomerInlineLabelInput }
              isEditable={ isEditable }
              label="TIN"
              id={ `customer-tax-residence[${ index }]-tin` }
              labelClass="form-label col-4"
              inputClass="form-input col-7"
            />
            <Field
              name="noTinReason"
              component={ CustomerInlineLabelInput }
              isEditable={ isEditable }
              label="No TIN Reason"
              id={ `customer-tax-residence[${ index }]-no-tin-reason` }
              labelClass="form-label col-4"
              inputClass="form-input col-7"
            />
            <Field
              name="noTinExplanation"
              component={ CustomerInlineLabelInput }
              isEditable={ isEditable }
              label="No TIN Explanation"
              id={ `customer-tax-residence[${ index }]-no-tin-explanation` }
              labelClass="form-label col-4"
              inputClass="form-input col-7"
            />
          </div>
        </div>
      </div>
    </div>
  </div>);

JotrFields.propTypes = {
  isEditable: PropTypes.bool,
  index: PropTypes.number.isRequired,
  isWithholdingResidence: PropTypes.bool,
  isPrimary: PropTypes.bool,
  jurisdictions: PropTypes.arrayOf(PropTypes.shape()),
  onRemoveTaxResidence: PropTypes.func.isRequired,
  onChangeWhdResidence: PropTypes.func,
  onMakePrimaryClick: PropTypes.func,
  isPrimaryEditable: PropTypes.bool.isRequired
};

JotrFields.defaultProps = {
  isEditable: false,
  isWithholdingResidence: false,
  isPrimary: false,
  jurisdictions: null,
  onChangeWhdResidence: null,
  onMakePrimaryClick: null
};

export default JotrFields;
